/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        17/03/2022 15:15
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

export default class CollapseService {
    trigger = '[data-hc-collapse]'

    constructor() {
        const collapse = document.querySelectorAll(this.trigger)
        if (collapse.length > 0) {
            import(
                '@iris.interactive/handcook/public/scripts/components/collapse/collapse.component' /* webpackChunkName: "scripts/hc_collapse" */
            ).then(({ default: hc_collapse }) => {
                hc_collapse()
            })
        }
    }
}
